<template>
  <div class="page-block__heading page-block__heading--withbar">
    <h3
      class="page-block__title">
      {{ subHeader }}
    </h3>
  </div>
</template>

<script>
export default {
  name: 'RevenueShareSubHeader',
  props: {
    subHeader: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
